import {Injectable} from '@angular/core';
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {NotificationComponent} from "./components/notification/notification.component";

@Injectable()
export class NotificationService {

  constructor(private modalService: NgbModal) {
  }

  error(title: string, message: string) {
    this.open(title, message, 'error');
  }

  warning(title: string, message: string) {
    this.open(title, message, 'warning');
  }

  info(title: string, message: string) {
    this.open(title, message, 'info');
  }

  open(title: string, message: string, type: 'info' | 'error' | 'warning') {
    const modal = this.modalService
      .open(NotificationComponent, {
        size: 'sm'
      });
    modal.componentInstance.title = title;
    modal.componentInstance.type = type;
    modal.componentInstance.message = message;
  }

}
